export const cognitoSpecialCharacters = /(?=.*[\^$*.[\]{}()?\-“!@#%&/,><’:;|_~`])/;
export const cognitoLowercase = /(?=.*[a-z])/;
export const cognitoNumber = /(?=.*[0-9])/;

export const validatePassword = (value: string) => {
  if (value.length < 8 || !value.match(cognitoNumber)) {
    return 'v2.global.textField_errorHandling_helperText_password_requirements_specialCharacter';
  }
  if (
    value.includes(' ') ||
    value.includes('\t') ||
    value.includes('\r') ||
    value.includes('\n')
  ) {
    return 'v2.global.textField_errorHandling_helperText_password_requirements_whitespace';
  }
  return '';
};
